import { useNavigate } from 'react-router-dom';

export function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="main-container">
      <h1>Newsletter</h1>
      <div className="main-container-middle">
        <p className="main-text">
          Information about titles available on MANGA MILLION will be sent by email. Newsletter
          subscription and unsubscription settings can be managed below.
        </p>
        <div>
          <p>*The email content will be delivered in English.</p>
          <p>*The newsletter is intended for ages 16 and up.</p>
          <p>
            *Please see the{' '}
            <a
              href="https://mangamillion.shueisha.co.jp/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service.
            </a>
          </p>
        </div>
      </div>
      <div className="newsLetter-buttons">
        <button className="secondary" onClick={() => navigate('/register')}>
          <span />
          <span>Subscribe</span>
          <img src="/assets/arrow_right.svg" alt="" width="24" height="24" />
        </button>
        <button className="btn-text" onClick={() => navigate('/unsubscribe')}>
          Unsubscribe
          <img src="/assets/arrow_right.svg" alt="" width="24" height="24" />
        </button>
      </div>
    </div>
  );
}
